'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { debounceTime } from 'rxjs/operators/debounceTime';
import { map } from 'rxjs/operators/map';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { switchMap } from 'rxjs/operators/switchMap';
import { FETCHED_LISTS } from '../actions/ActionTypes';
import { FETCH_LISTS_DEBOUNCE_MS } from '../constants/base';
import { receiveLists, requestedListsFailed, requestLists } from '../actions/ListsActions';
export default ((action$, _, {
  ListsClient
}) => action$.ofType(FETCHED_LISTS).pipe(debounceTime(FETCH_LISTS_DEBOUNCE_MS), switchMap(({
  payload: {
    offset,
    search
  }
}) => ListsClient.fetchAllLists(offset, search).pipe(map(receiveLists), catchError(error => of(requestedListsFailed(error))), startWith(requestLists())))));